<template>
  <div style="width: 425pt; height: 283px; margin-top: 30pt; margin-bottom: 30pt; font-family:微軟正黑體; ">
    <v-layout style="align-items: center; justify-content: center;" >
      <v-flex md5>
        <v-layout column>
          <v-flex>
            <p>
              <span style="margin-left: 5px; font-weight:bold; font-size:14pt;">取貨人：{{ customName }} </span>
            </p>
          </v-flex>
          <v-flex>
            <div style="margin-top: 5pt;">
              <img src="../../assets/images/Aspose.Words.da217999-3df7-493c-8a4f-44e0ecac4c22.001.png" width="160" height="40" alt="" style="position: absolute; z-index: 1;" />
              <span style="font-family:微軟正黑體; font-size:14pt; font-weight:bold; margin-left: 5pt; margin-top: 6pt; position: absolute; z-index: 1;">屈臣氏{{ shopName }}</span>
            </div>
          </v-flex>
          <v-flex>
            <p style="line-height:25pt; margin-top: 35pt;"><span style="font-family:微軟正黑體; font-weight:bold; font-size: 11pt;">訂單編號：{{ itemInfo.watsonsId }}</span></p>
          </v-flex>
          <v-flex>
            <p style="line-height:25pt"><span style="font-family:微軟正黑體; font-weight:bold; font-size: 11pt;">手機後三碼： {{ lastPhone }}</span></p>
          </v-flex>
          <v-flex>
            <p style="line-height:25pt">
              <span style="font-family:微軟正黑體; font-weight:bold; font-size: 11pt;">消費金額： {{ itemInfo.price }}</span>
            </p>
          </v-flex>
          <v-flex>
            <div style="font-size: 10pt; font-weight:bold; margin-top: 20pt;">
              <table>
                <tr>
                  <td>
                    <img src="@/assets/images/in-logo.svg" height="30"/>
                  </td>
                  <td>
                    <table>
                      <tr>
                        <td>I N N O V I S I O N 優 視 達</td>
                      </tr>
                      <tr>
                        <td>服務專線： 0800-060-019</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>

            </div>
          </v-flex>
          <v-flex>
            <p style="line-height:12pt; widows:2; orphans:2; margin-left: 5px;"><span style="font-family:'微軟正黑體'; font-size:6pt; font-weight:bold; margin: 0; padding: 0;">*為維護您的權益，請於門市內拆封</span></p>
            <p style="line-height:12pt; widows:2; orphans:2; margin-left: 5px;"><span style="font-family:'微軟正黑體'; font-size:6pt; font-weight:bold; margin: 0; padding: 0;">確認商品及數量無誤。</span></p>
            <p style="line-height:12pt; widows:2; orphans:2; margin-left: 5px;"><span style="font-family:'微軟正黑體'; font-size:6pt; font-weight:bold; margin: 0; padding: 0;">商品售出，概不接受退換貨。</span></p>
          </v-flex>
        </v-layout>

      </v-flex>
      <v-flex md7>
        <v-layout column>
          <v-flex style="text-align: center;">
            <span style="font-family:微軟正黑體; font-weight:bold; font-size:14pt;">店家存根</span>
          </v-flex>
          <v-flex>
            <qrcode-vue style="display:block; margin:0 auto; text-align: center; margin-top: 5px;" :value="`69${itemInfo.watsonsId},69${itemInfo.price}`" :size="80" level="H" />
          </v-flex>
          <v-flex></v-flex>
          <v-flex></v-flex>
          <v-flex>
            <p style="line-height:31pt; margin-top: 20pt;">
              <span style="font-family:微軟正黑體; font-size:14pt; font-weight:bold; margin-left: 15px;">應收金額： {{ itemInfo.price }}</span>
              <span style="font-family:微軟正黑體; font-size:14pt; font-weight:bold; margin-right: 15px; float: right;">元</span>
            </p>
          </v-flex>
          <v-flex>
            <table cellspacing="0" cellpadding="0" class="TableGrid" style="width:226.1pt; margin-right:9pt; margin-left:9pt; border:1.5pt solid #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse; float:right">
              <tr style="height:27.2pt">
                <td style="width:101.5pt; border-right-style:solid; border-right-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; padding-right:4.65pt; padding-left:4.65pt; vertical-align:middle">
                  <p style="text-align:center; line-height:24pt"><span style="font-family:微軟正黑體; font-size:14pt; font-weight:bold">門市簽名</span></p>
                </td>
                <td style="width:101.5pt; border-left-style:solid; border-left-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; padding-right:4.65pt; padding-left:4.65pt; vertical-align:middle">
                  <p style="text-align:center; line-height:24pt"><span style="font-family:微軟正黑體; font-size:14pt; font-weight:bold">消費者簽收</span></p>
                </td>
              </tr>
              <tr style="height:60pt">
                <td style="width:101.5pt; border-top-style:solid; border-top-width:1.5pt; border-right-style:solid; border-right-width:1.5pt; padding-right:4.65pt; padding-left:4.65pt; vertical-align:middle">
                  <p style="text-align:center; line-height:24pt"><span style="font-family:微軟正黑體; font-size:14pt; font-weight:bold; -aw-import:ignore">&#xa0;</span></p>
                </td>
                <td style="width:101.5pt; border-top-style:solid; border-top-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; padding-right:4.65pt; padding-left:4.65pt; vertical-align:middle">
                  <p style="text-align:center; line-height:24pt"><span style="font-family:微軟正黑體; font-size:14pt; font-weight:bold; -aw-import:ignore">&#xa0;</span></p>
                </td>
              </tr>
            </table>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
  name: "PrintView",
  components: {
    QrcodeVue,
  },
  props: {
  },
  data() {
    return {
      width: "60%",
      dates: [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substring(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substring(0, 10),
      ],
      showDateMenu: false,
      shippingDate: "",
      shippingNumber: "",
      item:{
        phone: '',
        customName: '',
        shopNo: '',
        shopName: '',
        price: '',
        watsonsId: '',
      }
    };
  },
  created() {
    const query = this.$route.query;
    this.item.phone = query.phone;
    this.item.customName = query.customName;
    this.item.watsonsId = query.watsonsId;
    this.item.shopNo = query.shopNo;
    this.item.shopName = query.shopName;
    this.item.price = query.price;
  },
  computed: {
    itemInfo() {
      return this.item;
    },
    lastPhone() {
      return this.item.phone.slice(-3);
    },
    customName(){
      if(this.item) {
        return  this.item.customName.substring(0, 1) + '*' + this.item.customName.substring(1 + 1)
      } else {
        return '';
      }
    },
    shopName(){
      return this.item.shopName.replace(this.item.shopNo, '');
    }
  },
}
</script>

<style scoped>
body { widows:0; orphans:0; font-family:Calibri; font-size:12pt }p { margin:0pt }table { margin-top:0pt; margin-bottom:0pt }.NormalWeb { margin-top:5pt; margin-bottom:5pt; widows:2; orphans:2; font-family:新細明體; font-size:12pt }
.TableGrid { }
.page{
  margin: 20px;
  height: 425.196pt; width: 283.464pt;
}
.header {
  font-family: 微軟正黑體;
  font-size: 22pt;
  font-weight: bold;
  color: black;
}
.title {
  font-family: 微軟正黑體;
  font-size: 14pt;
  font-weight: bold;
  color: black;
}
@media print {
  .page {
    margin: 10px;
    height: 425.196pt; width: 283.464pt;
    box-shadow: initial;
    page-break-after: always;
  }
}


</style>
